import React from 'react'
import PropTypes from 'prop-types'

import Form from 'component/commonReport/Form'
import FormAnalytics from './FormAnalytics'
import Pagination from 'component/pagination/Pagination'
import Button from 'component/Button'
import CloseSVG from 'component/svgComponents/close'
import GeralVisionSVG from 'component/analyticsNew/BackToGeralVision'
import { ResizableBox } from 'react-resizable'
import ReactHtmlParser from 'react-html-parser'
import { browserHistory } from 'react-router'
import 'react-resizable/css/styles.css'
import 'styles/overwrittenAndNew/commonReport.css'
import * as spinnerActions from 'action/spinner'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { isEmpty } from '../../utils/validations'
import DownloadSVG from 'component/svgComponents/download'
import FilterSVG from 'component/svgComponents/filter'
import Glyph from 'component/utils/Glyph'
import Modal from 'component/queryLogsNew/Modal'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import moment from 'moment'

class CommonReport extends React.Component {
  constructor(props) {
    super(props)
    this.isResizingColumn = false

    this.state = {
      showTable: props.showTable,
      showFilters: false,
      response: {},
      lines: [],
      linesFixed: [],
      dtYear: "-",
      renderModal:false,
      log: null,
      headers: [],
      order: false,
      orderDirection: props.analyticsDetails ? 'desc' : 'asc',
      orderField: false,
      page: 1,
      pages: 0,
      limit: 10,
      formData: {},
      lastScroll: 0,
      isRefreshing: false,
      analyticsOptions: [
        {name: this.props.translate('analytics.per.store'), isActive: true, value: 'store'},
        {name: this.props.translate('analytics.per.LDAP'), isActive: false, value: 'ldap'},
        {name: this.props.translate('analytics.per.mission'), isActive: false, value: 'mission'}]
    }
  }

  componentDidMount() {
    const { onSubmit, showTable, fitTableInScreen, submitOnRender, emptyBranchs = false, initialFormData } = this.props

    this.checkProps()

    window.addEventListener('resize', () => {
      this.checkTableLayout()
    })

    window.addEventListener('scroll', () => {
      this.checkScroll()
    })


    if (showTable && !submitOnRender) onSubmit({}, this.callback)

    if (initialFormData && Object.keys(initialFormData).length > 0) {
      this.onSubmit(initialFormData)
    }

    if(emptyBranchs) this.toggleFilters(true)

    if (fitTableInScreen)
      window.addEventListener('resize', () => this.forceUpdate())


  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.columns !== this.props.columns) {
      this.checkProps()
    }

    if (!prevProps.update && this.props.update) {
      this.getData()
    }

    if(prevState.analyticsOptions !== this.state.analyticsOptions) {

      this.getData()
    }

  }

  checkScroll() {
    if (window.pageXOffset !== this.state.lastScroll) {
      this.setState({ lastScroll: window.pageXOffset })
      document.querySelector(
        '.part-overflow .headers'
      ).style.transform = `translateX(-${window.pageXOffset}px)`
    }
  }

  checkProps() {
    const headers = []
    const { columns, order, defaultOrder, limit } = this.props

    for (const i in columns) {
      columns[i].field = i
      columns[i].width = columns[i].label
        ? columns[i].label.length * 8.5 + 35
        : 110
      columns[i].width = columns[i].width < 110 ? 110 : columns[i].width
      if (!columns[i].fixed && columns[i].width > 150) {
        columns[i].width = 150
      }
      if (columns[i].customWidth) {
        columns[i].width = columns[i].customWidth
      }
      headers.push(columns[i])
    }

    if (limit) {
      this.setState({ limit })
    }

    if (order) {
      this.setState({ order: true })
    }

    if (defaultOrder) {
      this.setState({ orderField: defaultOrder })
    }

    this.setState({ headers })
  }

  buildLines() {
    const lines = []
    const linesFull = []
    const linesFixed = []
    const { response } = this.state
    const columns = this.props.columns || {}

    if (!(response && response.data && response.data.length))
      this.setState({ empytError: true })
    else this.setState({ empytError: false })

    for (const item of response.data || []) {
      const line = []
      const lineFull = []
      const lineFixed = []
      
      for (const i in columns) {
        if (typeof item[i] !== 'undefined') {
          const col = { key: '', value: '', class: '', primaryKey: ''}
          
          col.key = i
          col.value = item[i]
          if (columns[i].checkNegative && item[i].indexOf('- ') !== -1) {
            col.value = <span className='negative-number'>{item[i]}</span>
          }
          lineFull.push(col)
          if (columns[i].fixed) lineFixed.push(col)
          else line.push(col)
        } else {
          const col = { key: '', value: '', class: '' }
          col.key = i
          lineFull.push(col)
          if (columns[i].fixed) lineFixed.push(col)
          else line.push(col)
        }
      }
      linesFull.push(lineFull)
      lines.push(line)
      linesFixed.push(lineFixed)
    }

    this.setState({ linesFull, lines, linesFixed }, () => {
      this.checkTableLayout()
    })
  }

  onSubmit(form) {

    this.toggleFilters(false)
    this.setState({ formData: form, showTable: true, page: 1 }, () => {
      this.getData()
    })
  }

  onSubmitFlux(form) {
    this.toggleFilters(false)
    this.setState({ formData: form, showTable: true, page: 1 }, () => {
      this.getData(true)
    })
  }

  onPageChange(page) {
    this.setState({ page }, () => {
      const hasFlux = !!this.props.onSubmitFlux
      this.getData(hasFlux)
    })
  }

  getData(isFlux = false, reactiveCallback = null) {

    const { limit, page, orderField, orderDirection, formData } =this.state
    const { showSpinner, controlledSpinner, analyticsDetails, hideSpinner } = this.props

    if(!controlledSpinner && !analyticsDetails) {
      if (reactiveCallback) {
        showSpinner("", true, reactiveCallback)
      } else {
        showSpinner()
      }
    }

    if(analyticsDetails && !reactiveCallback) {
      const abortController = new AbortController()
      showSpinner("", true, () => {
        abortController.abort()
        hideSpinner()
      })
    }

    const body = { ...formData };

    body.page = page
    body.limit = limit

    if (orderField) {
    body.orderField = orderField;
    }
    if (orderDirection) {
      body.orderDirection = orderDirection;
    }

    const option = this.state.analyticsOptions.find(op => op.isActive)

    if(!isFlux) this.props.onSubmit(body, this.callback, option.value )
    else this.props.onSubmitFlux(body, this.callback, option.value)
  }

  callback = (data) => {
    const { limit } = this.state
    const { hideSpinner } = this.props

    const { total, year } = data
    const pages = total ? Math.ceil(total / limit) : 0

    if(year) this.setState({dtYear: year})
    this.setState({ response: data, pages, isRefreshing: false }, () => {
      this.buildLines()

      hideSpinner()

      window.scroll(0, 0)
    })
  }

  handleRefresh = () => {
    const { showTable, formData } = this.state
    const { hideSpinner } = this.props

    // only refresh if there is a previous query (formData) and table is visible
    if (!showTable || !formData || Object.keys(formData).length === 0) return

    this.setState({ isRefreshing: true }, () => {
      const hasFlux = !!this.props.onSubmitFlux
      this.getData(hasFlux, () => {
        this.setState({ isRefreshing: false }, () => {
          hideSpinner()
        })
      })
    })
  }

  onExport() {
    const { showSpinner, hideSpinner, analyticsDetails, fluxReport } = this.props

   if(!analyticsDetails && !fluxReport) showSpinner()
    
    this.props.onExport(() => {

     if(!analyticsDetails && !fluxReport) hideSpinner()
    })
  }

  order(field) {
    const { orderField, orderDirection } = this.state

    const newDirection =
    field === orderField && orderDirection === 'asc'
      ? 'desc'
      : 'asc';

    this.setState(
      {
        orderField: field,
        orderDirection: newDirection,
        page: 1,
      },
      () => this.getData()  
    );
  }

  toggleFilters(op) {
    this.setState({ showFilters: op })

    document.querySelector('body').style.overflow = op ? 'hidden' : 'auto'
  }

  checkTableLayout(e, col) {
    if (e) {
      const { headers } = this.state

      for (const h of headers) {
        if (h.field === col.field) {
          h.width = e.size.width
        }
      }
      this.setState({ headers })
    }

    setTimeout(() => {
      const linesFixed = document.querySelectorAll('.table-fixed tbody tr')
      const lines = document.querySelectorAll('.table-overflow tbody tr')
      let i = 0

      Array.from(lines).map((l) => {
        l.style.height = ''
      })
      Array.from(linesFixed).map((l) => {
        l.style.height = ''
      })

      for (const l of linesFixed) {
        if (l.offsetHeight !== lines[i].offsetHeight) {
          const height =
            l.offsetHeight > lines[i].offsetHeight
              ? l.offsetHeight
              : lines[i].offsetHeight
          l.style.height = `${height}px`
          lines[i].style.height = `${height}px`
        }
        i++
      }
    }, 200)
  }

  getTableWidth(table) {
    const { headers } = this.state
    let width

    if (headers.length === 0) {
      return 0
    }

    if (table === 'fixed') {
      width = headers.reduce(
        (value, v) => value + (v.fixed ? v.width + 40 : 0),
        0
      )
    } else if (table === 'overflow') {
      width = headers.reduce(
        (value, v) => value + (!v.fixed ? v.width + 40 : 0),
        0
      )
    } else {
      width = headers.reduce((value, v) => value + (v.width + 40), 0)
    }

    return `${width}px`
  }

  renderValue(val) {
    if(val === null || val === "null - null"){
      return '-'
    }

    return typeof val === 'object' || typeof val === 'number'
      ? val
      : ReactHtmlParser(val)
  }

  handleAnalyticsOptions = (name) => {

    const {analyticsOptions} = this.state

    this.setState({
      analyticsOptions: analyticsOptions.map(op => op.name === name ? {...op, isActive: true} : {...op, isActive: false})
    })
}

  handleDownload = (log) => {
    const { translate, isStockTransfer } = this.props
    const element = document.createElement('a')
    const functionalitySuffix = isStockTransfer ? 'score.stock.request' : 'score.irc'
    const functionalityLine = translate(`query.logs.${functionalitySuffix}`)

    const file = new Blob(
      [
        `\n${translate('query.logs.modal.functionality')}\n`,
        functionalityLine,
        '\n\n',
        translate('query.logs.modal.date'),
        '\n',
        moment(log.date).format('l'),
        '\n\n',
        translate('query.logs.modal.hour'),
        '\n',
        moment(log.date).format('LT'),
        '\n\n',
        translate('queryLogs.table.column.endpoint'),
        '\n',
        log.endpoint,
        '\n\n',
        translate('query.logs.modal.request'),
        '\n',
        log.request,
        '\n\n',
        translate('query.logs.modal.response'),
        '\n',
        log.response,
      ],
      { type: 'text/plain' }
    )

    element.href = URL.createObjectURL(file)
    element.download = 'logs.txt'
    // Required for this to work in FireFox
    document.body.appendChild(element)
    element.click()
    element.parentElement.removeChild(element)
  }

  renderModal = () => {
    const { translate, isStockTransfer } = this.props
    const { renderModal, log } = this.state

    if (!renderModal) {
      return
    }

    const functionality = isStockTransfer ? 'score.stock.request' : 'score.irc'
    const modalData = {
      request: log && log.request,
      response: log && log.response,
      endpoint: log && log.endpoint,
      date: log && log.date,
      functionality,
    }

    return (
      <Modal
        closeModal={() =>
          this.setState({
            renderModal: false,
            log: null,
          })
        }
        handleDownload={this.handleDownload}
        data={modalData}
        translate={translate}
      />
    )
  }

  renderTable() {

    const {
      showTable,
      headers,
      linesFixed,
      order,
      orderField,
      orderDirection,
    } = this.state
    const {
      columns,
      hardOrder,
      translate,
      fitTableInScreen,
      wrapOnHeaderTextOverflow,
      analyticsDetails
    } = this.props

    const fixedColumnWidth =
      (window.innerWidth - 136) / Object.keys(columns).length
    const headerLabelClass = wrapOnHeaderTextOverflow
      ? 'report-header-wrap'
      : 'text-ellipsis'

    return (
      <div  className={`tables ${!showTable ? 'hidden' : ''} ${analyticsDetails ? 'analytics-details-remove-after' : ''}`}>
        <div className='left-overlay' />
        <div
          className='part-fixed'
          style={{
            width: fitTableInScreen
              ? window.innerWidth - 136
              : this.getTableWidth('fixed'),
          }}
        >
          <div className='headers' style={{top: analyticsDetails && '268px'}}>
            {(headers || []).map((v, i) => {
              if (v.fixed) {
                return (
                  <div
                    key={i}
                    className={
                      (v.align ? `text-${v.align}` : '') +
                      (order && !v.disableOrder ? ' order' : '') +
                      (order && v.disableOrder ? ' no-order' : '') +
                      (fitTableInScreen ? ' padding-fixed-w' : '')
                    }
                    onClick={() => {
                      if (!this.isResizingColumn && order && !v.disableOrder) {
                        this.order(v.field)
                      }
                    }}
                  >
                    {fitTableInScreen ? (
                      <div
                        style={{
                          width: `${fixedColumnWidth - 20}px`,
                          maxWidth: `${fixedColumnWidth - 20}px`,
                        }}
                      >
                        <b>
                          <span className={headerLabelClass}>
                            {translate(v.label)}
                          </span>
                        </b>
                      </div>
                    ) : (
                      <ResizableBox
                        className={`${analyticsDetails ? 'disable-resizable' : ''}`}
                        minConstraints={[80, 20]}
                        width={v.width}
                        height={20}
                        axis='x'
                        onResizeStart={() => {
                          this.isResizingColumn = true
                        }}
                        onResizeStop={(a, b) => {
                          this.checkTableLayout(b, v)
                          setTimeout(() => {
                            this.isResizingColumn = false
                          }, 0)
                        }}
                      >
                        <span>{translate(v.label)}</span>
                        {order && orderField === v.field && (
                          <svg
                            width='292.362px'
                            height='292.362px'
                            viewBox='0 0 292.362 292.362'
                            className={orderDirection}
                          >
                            <path d='M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z' />
                          </svg>
                        )}
                        {hardOrder && v.field === hardOrder && (
                          <svg
                            width='292.362px'
                            height='292.362px'
                            viewBox='0 0 292.362 292.362'
                            className={orderDirection}
                          >
                            <path d='M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z' />
                          </svg>
                        )}
                      </ResizableBox>
                    )}
                  </div>
                )
              }
            })}
          </div>
          <table style={{position: analyticsDetails && 'relative', top: analyticsDetails && '50px', backGroundColor: analyticsDetails && 'white'}} className='table table-fixed'>
            <thead>
              <tr>
                {(headers || []).map((v, i) => {
                  if (v.fixed) {
                    return (
                      <th key={i} width={`${v.width + 40}px`}>
                        &nbsp;
                      </th>
                    )
                  }
                })}
              </tr>
            </thead>
            <tbody>
              {(linesFixed || []).map((line, index) => (
                <tr key={index}>
                  {line.map((col, i) => (
                    <td
                      style={{
                        width: fitTableInScreen
                          ? `${fixedColumnWidth}px`
                          : undefined,
                        maxWidth: fitTableInScreen
                          ? `${fixedColumnWidth}px`
                          : undefined,
                      }}
                      key={i}
                      className={
                        col.class +
                        (columns[col.key] && columns[col.key].align
                          ? ` text-${columns[col.key].align}`
                          : '')
                      }
                    >
                      {this.renderValue(col.value)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div
          className='part-overflow'
          style={{ width: this.getTableWidth('overflow'), position: analyticsDetails && 'relative', top: analyticsDetails && '50px', backGroundColor: analyticsDetails && 'white' }}
        >
          {this.renderTableOverflow()}
        </div>
      </div>
    )
  }


  callLogDetail(id) {
    const {user, showSpinner, hideSpinner, isStockTransfer} = this.props
    if (!id) return

    const endpoint = isStockTransfer ? API_URL.FIND_BY_CODE_PROCESS : API_URL.FIND_LOG_DETAIL;

    showSpinner()

    new Api(user.dsToken)
    .get(endpoint, {id}, "")
    .then(resp => {
      this.setState({log: resp.data}, () => this.setState({renderModal: true}, () => hideSpinner()))
    })
    .catch(() => {
      hideSpinner()
    })
    
  }

  renderEyeIcon(id, rowIndex) {
    const { onEyeIconClick } = this.props
    const onClick = onEyeIconClick
      ? () => onEyeIconClick(id, rowIndex)
      : () => this.callLogDetail(id)

    return (
      <Glyph
        font={20}
        type='eye'
        color='primary'
        onClick={onClick}
      />
    
    )
  }

  renderSafeValue = (value) => value === null || value === undefined || value === '' ? '-' : value

  renderTableOverflow() {
    const { headers, order, orderField, orderDirection, lines, analyticsOptions } = this.state
    const { columns, translate, analyticsDetails , eyeIcon} = this.props

    return (
      <>
        <div
          className='headers'
          style={{ marginLeft: this.getTableWidth('fixed'), top: analyticsDetails && '268px' }}
        >

          {analyticsDetails &&
            <div className='analytics-details-options' >
              {analyticsOptions.map((op,idx) =>
                <button disabled={isEmpty(this.state.formData.branchIdList)} onClick={() => this.handleAnalyticsOptions(op.name, idx)} key={op.name} className={op.isActive ? 'isActive' : ''}>{op.name}</button>)}
            </div>
          }

          {(headers || []).map((v, i) => {
            if (!v.fixed) {
              return (
                <div
                  key={i}
                  className={
                    (v.align ? `text-${v.align}` : '') +
                    (order && !v.disableOrder ? ' order' : '') +
                    (order && v.disableOrder ? ' no-order' : '')
                  }
                  onClick={() => {
                    if (!this.isResizingColumn && order && !v.disableOrder) {
                      this.order(v.field)
                    }
                  }}
                >
                  <ResizableBox
                    className={`${analyticsDetails ? 'disable-resize' : ''}`}
                    minConstraints={[80, 20]}
                    width={v.width}
                    height={20}
                    axis='x'
                    onResizeStart={() => {
                      this.isResizingColumn = true
                    }}
                    onResizeStop={(a, b) => {
                      this.checkTableLayout(b, v)
                      setTimeout(() => {
                        this.isResizingColumn = false
                      }, 0)
                    }}
                  >
                    <span>{translate(v.label)}</span>
                    {order && orderField === v.field && (
                      <svg
                        width='292.362px'
                        height='292.362px'
                        viewBox='0 0 292.362 292.362'
                        className={orderDirection}
                      >
                        <path d='M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z' />
                      </svg>
                    )}

                  </ResizableBox>
                </div>
              )
            }
          })}
        </div>
        <table className='table table-overflow'>
          <thead>
            <tr>
              {(headers || []).map((v, i) => {
                if (!v.fixed) {
                  return (
                    <th key={i} width={`${v.width + 40}px`}>
                      &nbsp;
                    </th>
                  )
                }
              })}
            </tr>
          </thead>
          <tbody>
            {(lines || []).map((line, index) => (
              <tr key={index}>
                {line.map((col, i) => {
                  if (!columns[col.key]) return null
                  return (
                    <td
                      key={i}
                      className={
                        col.class +
                        (columns[col.key].align
                          ? ` text-${columns[col.key].align}`
                          : '')
                      }
                    >
                      {
                        col.key === "dtInventory" ? (() => {
                          const formattedDate = col.value ? col.value.split(" ")[0] : "";
                          return <span>{formattedDate}</span>;
                        })() : col.key === "requestLog" ? (
                          col.value === "" || col.value === null ? (
                            <div style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}>
                              <span>-</span>
                            </div>
                          ) : eyeIcon && (
                            <div style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}>
                              {this.renderEyeIcon(this.props.idsList[index], index)}
                            </div>
                          )
                        ) : eyeIcon && col.key === "integrated" && (col.value === "Sim" || col.value === "Não") ? (
                          <div style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}>
                            <span>{col.value}</span>
                            {this.renderEyeIcon(this.props.idsList[index], index)}
                          </div>
                        ) : (
                          this.renderValue(this.renderSafeValue(col.value))
                        )
                      }

                    </td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </>
    )
  }

  render() {
    const {
      showTable,
      showFilters,
      response,
      page,
      pages,
      empytError,
    } = this.state
    const {
      fields,
      onExport,
      topLeftPart,
      user,
      translate,
      emptyReportMsg,
      analyticsDetails,

    } = this.props

    const buildLines = () => {
      this.getData()
    }

    const activeAnalyticsTab = this.state.analyticsOptions.find(v => v.isActive)

    return (

    <>
      
      {this.renderModal()}
      <div className={`common-report`}>
        <div className='title'>
          <h1>{this.props.title}</h1>
        </div>
        <div className='content'>
          <div
            className={`filters-overlay ${
              showFilters && showTable ? 'show' : ''
            }`}
          />
          <div
            className={`filters ${showTable ? 'fixed' : ''} ${
              showFilters ? 'open' : ''
            }`}
          >
            <div className='close' style={{...(analyticsDetails && { right: 43 })}} onClick={() => this.toggleFilters(false)}>
              <CloseSVG />
            </div>
            <h2>{translate('commonReport.filters')}</h2>
            {analyticsDetails ?
              <FormAnalytics
                isWeb={this.props.isWeb}
                getData={buildLines}
                fields={fields || []}
                onSubmit={(form) => this.onSubmit(form)}
                user={user}
                translate={translate}
                value={[]}/>
              :
              <Form
                onSubmitFlux={(form) => this.onSubmitFlux(form)}
                fluxPOC={this.props.fluxPOC}
                fields={fields || []}
                onSubmit={(form) => this.onSubmit(form)}
                user={user}
                translate={translate}
                value={[]}
              />}

          </div>
          <div className={`top ${!showTable ? 'hidden' : ''}`}>
            <div className='left'>{topLeftPart && !this.props.showDate && topLeftPart()}

              {!this.props.backToVision && this.props.showDate &&

                <div style={{display: 'flex'}}>
                  <span
                  style={{display: 'flex', alignItems: 'center', fontSize: '36px', fontWeight: 'bold', marginRight: '24px'}}
                  className='report-top-data ' >{this.state.dtYear} </span>
                  <div>
                    {topLeftPart()}
                  </div>
                </div>

              }

              {this.props.backToVision &&

                <Button
                onClick={() => browserHistory.push('/analytics-new')}
                className='btn geral-vision'
                svgIcon
                svgComponent={< GeralVisionSVG className='eye-svg' />}
                text={translate('commonReport.backGeralVision')} />
              }

            </div>

            <div className='right'>
              {typeof onExport === 'function' && (
                <>
                  {this.props.showRefreshButton && (
                    <button
                      className='btn refresh'
                      onClick={() => this.handleRefresh()}
                      disabled={!this.state.showTable || this.state.isRefreshing || !this.state.formData || Object.keys(this.state.formData).length === 0}
                    >
                      <span>{translate('commonReport.refresh')}</span>
                    </button>
                  )}
                  <button
                    className='btn download'
                    onClick={() => this.onExport()}
                  >
                    <DownloadSVG className={"common-download"}/>
                    <span>{analyticsDetails && activeAnalyticsTab.value !== "ldap" ? "Baixar Relatório Detalhado" : translate('commonReport.download')}</span>
                  </button>
                </>
              )}
              <button className='btn' onClick={() => this.toggleFilters(true)}>
                <FilterSVG className="common-download"/>
                <span>{translate('commonReport.filters')}</span>
              </button>
            </div>

          </div>

          <div style={{width: analyticsDetails && '100%', backgroundColor: !empytError && analyticsDetails && 'white', marginTop: !empytError && analyticsDetails && '30px'}} className='fit-content'>

            {this.renderTable()}
            {empytError && emptyReportMsg && (
              <div style={{marginTop: analyticsDetails && '35px'}} className='notification notification-warning'>
                {translate(emptyReportMsg)}
              </div>
            )}
          </div>
          {!showTable || pages < 2 || (
            <Pagination
              navClass='pagination'
              count={response.total}
              current={page}
              getPage={(e) => {
                this.onPageChange(e)
              }}
              pages={pages}
            />
          )}
        </div>
      </div>
    </>
    )
  }
}

CommonReport.propTypes = {
  showDate: PropTypes.bool,
  showTable: PropTypes.bool,
  title: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
  columns: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onExport: PropTypes.func,
  onCancel: PropTypes.func,
  fitTableInScreen: PropTypes.bool,
  order: PropTypes.bool,
  defaultOrder: PropTypes.string,
  topLeftPart: PropTypes.any,
  user: PropTypes.object,
  translate: PropTypes.func.isRequired,
  limit: PropTypes.number,
  hardOrder: PropTypes.string,
  wrapOnHeaderTextOverflow: PropTypes.bool,
  emptyReportMsg: PropTypes.string,
  update: PropTypes.bool,
  showSpinner: PropTypes.func,
  fluxReport: PropTypes.bool,
  hideSpinner: PropTypes.func,
  backToVision: PropTypes.bool,
  analyticsDetails: PropTypes.bool,
  submitOnRender: PropTypes.bool,
  setMissionColumns: PropTypes.func,
  emptyBranchs: PropTypes.bool,
  isWeb: PropTypes.bool,
  controlledSpinner: PropTypes.bool,
  fluxPOC: PropTypes.bool,
  onSubmitFlux: PropTypes.func,
  idsList: PropTypes.array,
  eyeIcon: PropTypes.bool,
  isStockTransfer: PropTypes.string,
  onEyeIconClick: PropTypes.func,
  initialFormData: PropTypes.object,
  showRefreshButton: PropTypes.bool,
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...spinnerActions },
    dispatch
  )

export default connect(() => ({}), mapDispatchToProps)(CommonReport)
export { CommonReport }
